import {takeEvery} from 'redux-saga/effects'
import {
  COPY_TERM_EXAMS,
  GET_EXAM_DETAIL,
  GET_EXAM_DETAIL_REPORT,
  GET_UNMARKED_STUDENTS_REPORT,
} from 'setup/redux/Actions/ExamTools/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_EXAM_DETAIL, fetchData)
  yield takeEvery(COPY_TERM_EXAMS, fetchData)
  yield takeEvery(GET_UNMARKED_STUDENTS_REPORT, fetchData)
  yield takeEvery(GET_EXAM_DETAIL_REPORT, fetchData)
}

export default dataSaga
